// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fa3c10bc","239":"c73603c7","453":"10e7ec15","455":"fdb3b919","483":"ad6c55e0","512":"69c7c2bb"}[chunkId] + ".chunk.js";
};